// 微信js-sdk
import wx from 'weixin-js-sdk';
import {ExpediteService, UserCenterService} from "@/common/service";
import {WX_APP_ID} from "@/common/config";

export const appid = WX_APP_ID;

/**
 * 获取url中的code
 * @param url
 */
export const getUrlCode = (url) => {
    if (url.indexOf('/?code') > -1) {
        const urlArr = url.split('/?')
        const leftUrl = urlArr[0] + '/#/'
        const rightUrlArr = urlArr[1].split('#/')
        const queryObj = {}
        // 获取code和state参数
        rightUrlArr[0]
            .split('&')
            .map((item) => {
                const splitStr = item.split('=')
                return {
                    key: splitStr[0],
                    value: splitStr[1],
                }
            })
            .forEach((item) => {
                queryObj[item.key] = item.value
            });
        const code = queryObj.code;

        // 使用微信code请求后台接口拿openId等你业务参数
        UserCenterService.saveOpenid({code}).then(() => {
            console.log('UserCenterService.saveOpenid: success');
            // 获取成功
        }).finally(() => {
            location.href = (`${leftUrl}${rightUrlArr[1]}`);
        });
    }
};

/**
 * 获取code
 */
export const getCode = () => {
    const url = location.href.split('/#')[0];
    const baseUrl = 'https://open.weixin.qq.com/connect/oauth2/authorize';
    // snsapi_base （不弹出授权页面，直接跳转，只能获取用户openid）
    // snsapi_userinfo （弹出授权页面，可通过 openid 拿到昵称、性别、所在地。并且， 即使在未关注的情况下，只要用户授权，也能获取其信息 ）
    const scope = 'snsapi_base';
    location.href = `${baseUrl}?appid=${appid}&redirect_uri=${url}&response_type=code&scope=${scope}&state=STATE#wechat_redirect`;
}

/**
 * 初始化jssdk
 */
export const initJssdk = () => {
    // 根据接口返回config信息
    ExpediteService.getWeChatSign({
        // 注意：url必须为在安全域名下的页面全路径，hash之前的部分，否则会出现获取不到api权限的问题
        url: window.location.href.split('#')[0],
    }).then(({ data }) => {
        let result = data;
        wx.config({
            // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
            debug: false,
            appId: result.appid, // 必填，公众号的唯一标识
            timestamp: result.timestamp, // 必填，生成签名的时间戳
            nonceStr: result.noncestr, // 必填，生成签名的随机串
            signature: result.sign, // 必填，签名
            jsApiList: [
                'chooseWXPay',
                'chooseImage',
                'previewImage',
                'updateAppMessageShareData',
                'updateTimelineShareData',
            ], // 必填，需要使用的JS接口列表
            openTagList: ['wx-open-launch-weapp'] // h5跳小程序
        })

        wx.ready(() => {
            // config信息验证后会执行ready方法，所有接口调用都必须在config接口获得结果之后，
            // config是一个客户端的异步操作，所以如果需要在页面加载时就调用相关接口，
            // 则须把相关接口放在ready函数中调用来确保正确执行。
            // 对于用户触发时才调用的接口，则可以直接调用，不需要放在ready函数中。
        })
        wx.error(function (res1) {
            // config信息验证失败会执行error函数，如签名过期导致验证失败，具体错误信息可以打开config的debug模式查看，
            //也可以在返回的res参数中查看，对于SPA可以在这里更新签名。
        });
    }).catch(err => {
        console.log('err', err)
    });
}
